module.exports = __webpack_public_path__ + "static/013-cd9bb2e178a5d7ed18e078dc0dc091dd.jpg";